
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punemumbaidailycabservice() {



    const cardData =
    {
        keyword: 'Pune Mumbai Daily Cab Service',
        heading: 'Meghana Cab : Pune Mumbai Daily Cab Service',
        headingDescription: 'Meghana Cab offers Pune Mumbai Daily Cab Service, designed for regular commuters, business professionals, and frequent travelers seeking a reliable and comfortable travel solution. Whether you are traveling for work, airport transfers, or daily commitments, our fleet—featuring Hatchbacks, Sedans, SUVs, and Innova Crysta—ensures timely pickups, clean interiors, and safe rides every day. With fixed schedules, affordable rates, courteous drivers, and 24/7 customer support, we make your intercity commute stress-free and dependable. Book your Pune to Mumbai Daily Cab with Meghana Cab and enjoy a punctual, convenient, and smooth ride—every single day.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

   "services": [
  {
    "name": "Daily Cab Pune to Mumbai",
    "description": "Reliable daily cab service from Pune to Mumbai for hassle-free and timely travel. Perfect for regular commuters, business travelers, and daily passengers seeking comfort and convenience."
  },
  {
    "name": "Everyday Cab Service Pune to Mumbai",
    "description": "Everyday cab rides connecting Pune to Mumbai with flexible scheduling and professional drivers, ensuring a smooth and safe journey every day."
  },
  {
    "name": "Pune Mumbai Regular Taxi",
    "description": "Regular taxi services between Pune and Mumbai designed for frequent travelers who need dependable transportation with transparent pricing."
  },
  {
    "name": "Online Daily Cab Booking Pune to Mumbai",
    "description": "Book your daily cab from Pune to Mumbai online effortlessly. Enjoy quick booking, multiple payment options, and confirmed rides with ease."
  },
  {
    "name": "One Way Daily Cab Pune to Mumbai",
    "description": "One way daily cab services for Pune to Mumbai travel, ideal for single trips with flexible timings and reliable service."
  },
  {
    "name": "Round Trip Daily Taxi Pune to Mumbai",
    "description": "Round trip daily taxi service between Pune and Mumbai for commuters who need both onward and return travel covered with comfort and punctuality."
  },
  {
    "name": "Budget Daily Cabs Pune to Mumbai",
    "description": "Affordable daily cab services from Pune to Mumbai without compromising on safety or comfort, perfect for budget-conscious travelers."
  },
  {
    "name": "AC Sedan Daily Service Pune to Mumbai",
    "description": "Travel cool and comfortable with our AC Sedan daily cab service between Pune and Mumbai, equipped with modern amenities and driven by professionals."
  },
  {
    "name": "SUV Daily Ride Pune to Mumbai",
    "description": "Spacious and powerful SUV rides available daily from Pune to Mumbai, suitable for groups and travelers needing extra luggage space."
  },
  {
    "name": "Corporate Daily Travel Pune to Mumbai",
    "description": "Dedicated corporate daily travel service from Pune to Mumbai with premium vehicles and discreet chauffeurs to meet business travel demands."
  },
  {
    "name": "Chauffeur Cab Pune to Mumbai Daily",
    "description": "Sit back and relax with our chauffeur-driven daily cab service from Pune to Mumbai, prioritizing your comfort, safety, and punctuality."
  },
  {
    "name": "Private Daily Taxi Pune to Mumbai",
    "description": "Exclusive private daily taxi rides from Pune to Mumbai, ensuring privacy and personalized service for each passenger."
  },
  {
    "name": "24/7 Daily Cab Service Pune Mumbai",
    "description": "Round-the-clock daily cab service from Pune to Mumbai, available any time of day or night for your convenience and travel flexibility."
  },
  {
    "name": "Comfortable Cab Daily Pune to Mumbai",
    "description": "Enjoy a comfortable daily cab ride between Pune and Mumbai with well-maintained vehicles and attentive drivers."
  },
  {
    "name": "Fast Daily Booking Pune to Mumbai",
    "description": "Quick and hassle-free daily cab booking from Pune to Mumbai with instant confirmations and multiple booking options."
  }
],
"tableData": [
  ["Daily Cab Pune to Mumbai", "Everyday Cab Service Pune to Mumbai"],
  ["Pune Mumbai Regular Taxi", "Online Daily Cab Booking Pune to Mumbai"],
  ["One Way Daily Cab Pune to Mumbai", "Round Trip Daily Taxi Pune to Mumbai"],
  ["Budget Daily Cabs Pune to Mumbai", "AC Sedan Daily Service Pune to Mumbai"],
  ["SUV Daily Ride Pune to Mumbai", "Corporate Daily Travel Pune to Mumbai"],
  ["Chauffeur Cab Pune to Mumbai Daily", "Private Daily Taxi Pune to Mumbai"],
  ["24/7 Daily Cab Service Pune Mumbai", "Comfortable Cab Daily Pune to Mumbai"],
  ["Fast Daily Booking Pune to Mumbai", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune Mumbai Daily Cab Service",
        "WhyChoosedescription": "Our daily cab service between Pune and Mumbai ensures dependable, punctual transportation for office-goers, frequent business travelers, students, and regular commuters. With fixed schedules and professional service, you can count on us every day of the week."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Fleet",
        "WhyChoosedescription": "Enjoy your daily travel in fully air-conditioned, regularly maintained cabs that offer spacious seating, smooth suspension, and a clean environment. Our vehicles are sanitized daily, ensuring hygiene and comfort for all passengers."
    },
    {
        "WhyChooseheading": "Professional Drivers with Daily Route Experience",
        "WhyChoosedescription": "Our drivers are experienced and familiar with the Pune–Mumbai Expressway and alternative routes, helping avoid traffic and delays. They are courteous, punctual, and dedicated to delivering a safe, comfortable ride every single day."
    },
    {
        "WhyChooseheading": "Cost-Effective and Transparent Pricing",
        "WhyChoosedescription": "Save more with our daily cab plans. We offer competitive, all-inclusive fares with no hidden charges. Enjoy discounted rates for regular bookings, office rides, and monthly subscriptions without compromising on service quality."
    },
    {
        "WhyChooseheading": "Flexible Timings and Custom Pickup Points",
        "WhyChoosedescription": "Choose from early morning, mid-day, or evening slots that align with your work schedule or travel needs. We also offer custom pickup and drop-off locations in both Pune and Mumbai to match your convenience."
    },
    {
        "WhyChooseheading": "Ideal for Office Commutes, Business Travel, and Regular Visits",
        "WhyChoosedescription": "Whether you're a working professional commuting daily, a student attending classes, or someone who travels regularly for meetings or family visits, our service is designed to make your daily Pune–Mumbai travel effortless."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-Off Service",
        "WhyChoosedescription": "We provide doorstep pickup and drop-off so you can avoid unnecessary waiting or travel to pickup points. Reach your destination on time and in total comfort—every single day."
    },
    {
        "WhyChooseheading": "24/7 Support and Quick Booking Assistance",
        "WhyChoosedescription": "Our customer support is available round the clock to help you manage bookings, reschedule rides, or handle any special requests. You can book daily rides quickly online or by phone, with full assistance anytime you need it."
    }
]
















    }

const faqData = [
    {
        question: "What is Pune Mumbai Daily Cab Service?",
        answer: "Our Pune Mumbai Daily Cab Service offers convenient, reliable daily transportation between Pune and Mumbai."
    },
    {
        question: "Can I book a daily cab service for commuting between Pune and Mumbai?",
        answer: "Yes, you can book our daily cab service for regular commuting between the two cities."
    },
    {
        question: "What types of vehicles are available for the daily cab service?",
        answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, and Innova Crysta for your daily commute."
    },
    {
        question: "Is the daily cab service available on weekends and holidays?",
        answer: "Yes, our service operates every day including weekends and public holidays."
    },
    {
        question: "How do I book the Pune Mumbai Daily Cab Service?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for easy online booking."
    },
    {
        question: "What is the typical pick-up and drop-off time for daily cab service?",
        answer: "Pick-up and drop-off times are flexible and can be scheduled as per your convenience."
    },
    {
        question: "Are the fares for daily cab service fixed or negotiable?",
        answer: "Fares are competitive and transparent, with options for monthly packages available."
    },
    {
        question: "Are the drivers experienced for daily cab services between Pune and Mumbai?",
        answer: "Yes, our drivers are professional, punctual, and familiar with the route."
    },
    {
        question: "Can I request stops during the daily commute?",
        answer: "Yes, stops can be arranged if informed in advance."
    },
    {
        question: "What payment methods are accepted for daily cab service?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Arvind Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The daily cab service between Pune and Mumbai has made my commute hassle-free and comfortable.”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and punctual service for daily travel. Highly recommend Meghana Cab.”',
    },
];





































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune Mumbai Daily Cab Service",
  "description": "Reliable daily cab service between Pune and Mumbai. Book AC sedans, SUVs for one way or round trips with professional chauffeurs. 24/7 online booking for corporate and family travel.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune and Mumbai"
  },
  "serviceType": "Daily Cab Service",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-mumbai-daily-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune Mumbai Daily Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Reliable daily cab service between Pune and Mumbai. Book AC sedans, SUVs for one way or round trips with professional chauffeurs. 24/7 online booking for corporate and family travel." 
  />
  <meta 
    name="keywords" 
    content="Daily Cab Pune to Mumbai, Everyday Cab Service Pune to Mumbai, Pune Mumbai Regular Taxi, Online Daily Cab Booking Pune to Mumbai, One Way Daily Cab Pune to Mumbai, Round Trip Daily Taxi Pune to Mumbai, Budget Daily Cabs Pune to Mumbai, AC Sedan Daily Service Pune to Mumbai, SUV Daily Ride Pune to Mumbai, Corporate Daily Travel Pune to Mumbai, Chauffeur Cab Pune to Mumbai Daily, Private Daily Taxi Pune to Mumbai, 24/7 Daily Cab Service Pune Mumbai, Comfortable Cab Daily Pune to Mumbai, Fast Daily Booking Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punemumbaidailycabservice;